import React, {useEffect, useState} from "react";
import ButtonDisabled from "./img/disabled.png";
import ButtonPressed from "./img/pressed.png";
import ButtonNormal from "./img/normal.png";
import ButtonFocus from "./img/focus.png";

import {Col, Container, Row} from "react-bootstrap";
import "./style.scss";
import {LogoSVG} from "./logo.tsx";


export type AuthProps = {}

export const Auth: React.FC<AuthProps> = () => {

    const [enabled, setEnabled] = useState<boolean>(true);
    const [hover, setHover] = useState<boolean>(false);
    const [pressed, setPressed] = useState<boolean>(false);

    useEffect(()=> {
        setTimeout(()=> {
            setEnabled(true);
        },1000);
    })

    let imgSrc = ButtonDisabled;
    if (enabled) {

        if (pressed) {
            imgSrc = ButtonPressed;
        } else if (hover) {
            imgSrc = ButtonFocus;
        } else {
            imgSrc = ButtonNormal;
        }
    }


    const onMouseOver = () => {
        setHover(true);
    }
    const onMouseLeave = () => {
        setHover(false);
        setPressed(false);
    }

    const onMouseDown = () => {
        setPressed(true);
    }
    const onMouseUp = () => {
        setPressed(false);
    }
    const onClick = () => {
        if (enabled) {
            setEnabled(false);
            // @ts-ignore
            document.location = GoogleOAuthURL;
        }
    }

    return (
            <Container fluid={true}>
                <Row className={"vh-100"}>
                    <Col className="bg-brand" sm={0} md={0} lg={8}></Col>
                    <Col className="bg-light d-flex align-items-center justify-content-center">
                        <div className="text-center">
                            <LogoSVG
                                id="imgLogo"
                                width="100%"
                                className="transition-colors duration-500 w-48 desktop:w-52"
                                tabIndex={-1}
                                color="#6a739a"
                            />
                            <p><img className="my-3" id="btnGoogle" alt="Sign in with Google" src={imgSrc}
                                    onMouseOver={onMouseOver}
                                    onMouseLeave={onMouseLeave}
                                    onMouseDown={onMouseDown}
                                    onMouseUp={onMouseUp}
                                    onClick={onClick}
                            /></p>
                        </div>
                    </Col>
                </Row>
            </Container>
    );
}
